"use client"

import { useSyncExternalStore } from "react"

import {
  getLoginSessionVersion,
  subscribeLoginSession,
} from "@/lib/login-session"
import {
  workspaceSessionUser,
  workspaceSessionUserSubtitle,
  type WorkspaceSessionUser,
} from "@/lib/workspace-session-user"

/** Profile for the active sign-in flow; re-renders when the session changes. */
export function useWorkspaceSessionUser(): WorkspaceSessionUser {
  useSyncExternalStore(subscribeLoginSession, getLoginSessionVersion, () => 0)
  return workspaceSessionUser()
}

/** Active identity subtitle when the session holds more than one door. */
export function useWorkspaceSessionUserSubtitle(): string | null {
  useSyncExternalStore(subscribeLoginSession, getLoginSessionVersion, () => 0)
  return workspaceSessionUserSubtitle()
}
